import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the reminderEmails state domain
 */

const selectReminderEmailsDomain = (state) =>
  state.get("reminderEmails", initialState)

/**
 * Other specific selectors
 */
export const makeSelectConfigurationObject = () =>
  createSelector(selectReminderEmailsDomain, (state) =>
    state.get("configuration")
  )

export const makeSelectIsLoadingConfiguration = () =>
  createSelector(selectReminderEmailsDomain, (state) =>
    state.get("isLoadingConfiguration")
  )

export const makeSelectIsLoading = () =>
  createSelector(selectReminderEmailsDomain, (state) => state.get("isLoading"))
/**
 * Default selector used by ReminderEmails
 */

const makeSelectReminderEmails = () =>
  createSelector(selectReminderEmailsDomain, (substate) => substate.toJS())

export default makeSelectReminderEmails
export { selectReminderEmailsDomain }
